import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record as ImmutableRecord } from "immutable";
import { UserNotebookPermissions } from "models/interfaces/notebooks/user-notebook-permissions";
import NotebookResourcePermissionRecord from "models/view-models/notebooks/notebook-resource-permission-record";

const defaultValues = RecordUtils.defaultValuesFactory<UserNotebookPermissions>(
    {
        permissionMap: {},
    }
);

export default class UserNotebookPermissionsRecord
    extends ImmutableRecord(defaultValues)
    implements UserNotebookPermissions
{
    constructor(params?: Partial<UserNotebookPermissions>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.permissionMap != null) {
            const newPermissionMap: Record<
                number,
                NotebookResourcePermissionRecord[]
            > = {};

            for (const [notebookId, permissions] of Object.entries(
                params.permissionMap
            )) {
                newPermissionMap[Number(notebookId)] =
                    RecordUtils.ensureRecords(
                        permissions ?? [],
                        NotebookResourcePermissionRecord
                    );
            }

            params.permissionMap = newPermissionMap;
        }

        super(params);
    }

    public with(
        values: Partial<UserNotebookPermissions>
    ): UserNotebookPermissionsRecord {
        return new UserNotebookPermissionsRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
